import {Link} from "react-router-dom";
import icUserDefault from "assets/images/ic-user-profile.svg";
import Badge from "components/commons/badge";

export const TABLE_NON_EMPLOYEE_LIST =  {
        name: 'Non-Employee List',
        column: [
            {
                name: "Name",
                key: "full_name",
                className: "font-semibold",
                sortable: true,
                render: ({item}) => {
                    return (
                        <div className={'flex flex-row gap-3 items-center'}>
                            <img className={'w-7 h-7 rounded-full border border-neutral-50'}
                                 src={item?.profile_picture ? item?.profile_picture : icUserDefault}
                                 alt={'user-img'}/>
                            <div>
                                {
                                    item?.status === 'draft' ?
                                        <div className={'cursor-pointer'}
                                             onClick={(e) => {
                                                 e.stopPropagation();
                                                 window.open(`/non-employee-worker/add-non-employee?draftId=${item.id}`, '_blank', 'noopener,noreferrer')
                                             }}>
                                            {item?.full_name}
                                        </div>
                                        :
                                        <Link to={`/non-employee-worker/detail-non-employee?userId=${item?.id}`}>
                                            <div>{item?.full_name}</div>
                                        </Link>
                                }
                            </div>
                        </div>
                    )
                }   
            },
            {
                name: "NIP",
                key: "nip",
                sortable: true,
            },
            {
                name: "Position",
                key: "job_title_by_contract",
                className: "font-semibold",
                sortable: true,
            },
            {
                name: "Employee Type",
                key: "type",
                className: "capitalize",
                render: ({value}) => value.replace('-', ' ')
            },
            {
                name: "Email",
                key: "email",
                sortable: true,
                render: ({item}) => item?.office_email ? item?.office_email : item?.personal_email
            },
            {
                name: "Join Date",
                sortable: true,
                key: "join_date",
            },
            {
                name: "Status",
                key: "status",
                render: ({value}) => <Badge title={value} type={value}/>
            }
        ]
    }



export const getStatus = {
    'registered': ["draft", "submitted", "registered"],
    'active': ["active"],
    'inactive': ["inactive", "blacklist"]
}